"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardBase = void 0;
var cabecalho_card_component_1 = require("../cabecalho-card/cabecalho-card.component");
var rodape_card_component_1 = require("../rodape-card/rodape-card.component");
var card_base_component_1 = require("./card-base.component");
var CardBase = {
    Card: card_base_component_1.CardBase,
    CabecalhoCard: cabecalho_card_component_1.CabecalhoCard,
    RodapeCard: rodape_card_component_1.RodapeCard,
};
exports.CardBase = CardBase;
